<template>
  <div class="status-tracker-wrapper">
    <div class="status-titles">
      <div style="flex-grow: 0.2">Sent</div>
      <div>Processing</div>
      <div :class="{ 'danger-text': status === 'Completed (No Records Found)' }">Completed</div>
    </div>
    <div class="status-tracker">
      <div class="status-circle-outline" :class="{ 'status-circle-filled': status === 'Sent' }" />
      <div class="status-line" />
      <div
        class="status-circle-outline"
        :class="{ 'status-circle-filled': status === 'Processing' }"
      />
      <div class="status-line" />
      <div
        class="status-circle-outline"
        :class="{ 'status-circle-filled': status === 'Completed' }"
      />
    </div>
    <div v-if="status === 'Completed (No Records Found)'" class="no-results">
      <v-icon style="color: #ff0000; margin-right: 5px">mdi-alert-circle-outline</v-icon>
      No Records Found
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusTracker',
  props: {
    status: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
.status-tracker-wrapper {
  display: flex;
  flex-direction: column;
}

.status-tracker {
  display: flex;
  align-items: center;
  margin: 10px 25px 10px 10px;
}

.status-titles {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #5F6368;
  font-weight: 400;
}

.status-circle-outline {
  width: 35px;
  height: 16px;
  border-radius: 100%;
  background: #fff;
  border: 1px solid #9B9B9B;
}

.status-line {
  height: 1px;
  background: #9B9B9B;
  width: 100%;
}

.status-circle-filled {
  background: #5F6368;
}

.danger-text {
  color: #ff0000;
}

.no-results {
  display: flex;
  align-items: center;
  color: #ff0000;
  margin-left: 8px;
}
</style>
